import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';

@Component({
  selector: 'app-authorization',
  templateUrl: './authorization.component.html',
  styleUrls: ['./authorization.component.css']
})
export class AuthorizationComponent implements OnInit, OnChanges {
  @Input() selectedAuthModel: any;
  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  @Input() authModels = [
    // {'display_name': 'Inherit from calling APIs',
    //   'value': 'inherit'},
    // {'display_name': 'No Authorization',
    //   'value': 'no_auth'},
    {'display_name': 'No Authorization',
      'value': 'no_auth'},
    {'display_name': 'Inherit from Parent',
      'value': 'inherit'},
    {'display_name': 'API Key',
      'value': 'api_key'},
    {'display_name': 'Bearer Token',
      'value': 'bearer_token'},
    {'display_name': 'Basic Authorization',
      'value': 'basic_authentication'},

    // {'display_name': 'Digest Authorization',
    //   'value': 'digest'},
    {'display_name': 'OAuth 1.0',
      'value': 'oauth_1_0'},
    {'display_name': 'OAuth 2.0',
      'value': 'oauth_2_0'},
    // {'display_name': 'Hawk Authentication',
    //   'value': 'hawk'},
    {'display_name': 'AWS Signature',
      'value': 'aws_signature'},
    {'display_name': 'API Connectors',
      'value': 'connector'}
  ];

  apiKeyAddToModels = [
{'display_name': 'Headers',
  'value': 'header'},
{'display_name': 'Query Params',
    'value': 'query_param'}
  ];

  oath1AddToModels = [
    {'display_name': 'Request Body',
      'value': 'request_body'},
    {'display_name': 'Request URL',
      'value': 'request_url'},
    {'display_name': 'Headers',
      'value': 'header'}
  ];

  signatureMethods = [
    {'display_name': 'HMAC-SHA1',
      'value': 'hmac_sha1'},
    {'display_name': 'HMAC-SHA256',
      'value': 'hmac_sha256'},
    {'display_name': 'Plain Text',
      'value': 'plaintext'}
  ];
  tempType: any;
  loaded = false;
  authModel: any;
  authAttributes = {};
  @Output() addTo = new EventEmitter<any>();
  @Input() authModel1;

  @Input() showAuthTypeSelector = true;

  registeredConnectors: any;
  apiConnectorList = [];

  selectedConnectorName = '';

  constructor(public platform: LeftpanelComponent, private confPost: ConfService) {}

  stringifyjson(val) {
    return JSON.stringify(val);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.authModel1) {
      this.authModel = this.authModel1;
    } else {
      this.authModel = {
        'authAttributes': this.authAttributes
      };
    }
  }

  getMyConnectors = () =>  {
    return new Promise((resolve, reject) => {
      if (this.platform.registeredConnectors !== null && this.platform.registeredConnectors !== undefined) {
        this.registeredConnectors = this.platform.registeredConnectors;
        this.registeredConnectors.forEach(registeredConnector => {
          if (registeredConnector['connectors']) {
            const connectorList = registeredConnector['connectors'];
            if (connectorList) {
              connectorList.forEach(connector => {
                if (connector['status'] === true)
                connector['temporaryProducer'] = registeredConnector['producer'];
                connector['temporaryDisplayName'] = registeredConnector['producer'] + '_' + connector['authType'] + '_' + connector['name'];
                this.apiConnectorList.push(connector);
              });
            }
          }
        });
        resolve('success');
      } else {
        this.confPost.getData('services', 'services', 'v1','apiconnectors', 'partner=' + this.partner + '&account=' + this.account)
            .toPromise().then(data => {
              this.registeredConnectors = data;
              this.platform.registeredConnectors = data;
              this.registeredConnectors.forEach(registeredConnector => {
                if (registeredConnector['connectors']) {
                  const connectorList = registeredConnector['connectors'];
                  if (connectorList) {
                    connectorList.forEach(connector => {
                      if (connector['status'] === true)
                        connector['temporaryProducer'] = registeredConnector['producer'];
                        connector['temporaryDisplayName'] = registeredConnector['producer'] + '_' + connector['authType'] + '_' + connector['name'];
                        this.apiConnectorList.push(connector);
                    });
                  }
                }
              });
              resolve('success');
            }, error => {
              resolve('failed');
            });
      }
    });
  };

  constructConnectorPayload() {
    const selectedConnector = this.apiConnectorList.filter((connector) => connector['name'] === this.selectedConnectorName);
    this.authModel['authAttributes']['type'] = selectedConnector[0]['authType'].toString().toLowerCase().replaceAll(' ', '_').replaceAll('.', '_');
    this.authModel['authAttributes']['name'] = selectedConnector[0]['name'];
    this.authModel['authAttributes']['producer'] = selectedConnector[0]['temporaryProducer'];
  }

  async ngOnInit() {
    if (this.authModel1) {
      this.authModel = this.authModel1;
    } else {
      this.authModel = {
        'authAttributes': this.authAttributes
      };
    }
    await this.getMyConnectors();
    this.loaded = true;
  }
  emitChangeAddto() {
    this.addTo.emit(this.authModel);
  }
  emitAddTo() {
    this.addTo.emit(this.authModel);
    if (this.tempType !== this.authModel['authType']) {
      this.tempType = this.authModel['authType'];
       if (this.authModel['authType'] === 'basic_authentication') {
        this.authModel['authAttributes'] = {};
        this.authModel['authAttributes']['username'] = '';
        this.authModel['authAttributes']['password'] = '';
      } else {
        this.authModel['authAttributes'] = {};
      }
    }
  }
  getAuthModel() {
    if (this.authModel['authType'] === 'no_auth') {
      delete this.authModel['authType'];
    }
    return this.authModel; 
  }
}
